exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".client-details-wrapper[data-v-64deef34]{border:1px solid #ecf0f1;margin:0 1px 15px;padding:5px 0}.el-icon-close[data-v-64deef34]{opacity:.75;transform:scale(.8);cursor:pointer;margin-left:10px;color:#13ce66}.el-icon-close[data-v-64deef34]:hover{color:#48576a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-64deef34&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/public/components/home/Home.vue
// module id = 591
// module chunks = 0